<template>
  <MediumModal
    :is-open="open"
    @close="close"
  >
    <template #header>
      <span> Create Inventory Count </span>
    </template>

    <div>
      <div class="grid grid-cols-2 gap-5">
        <div class="input-group col-span-1 relative">
          <label for="count_date"> Count Date </label>
          <DatePicker
            color="gray"
            title-position="right"
            v-model="date"
          >
            <template v-slot="{ inputValue, inputEvents }">
              <div class="relative">
                <CalendarIcon
                  class="top-2.5 left-3 h-4 w-4 text-blue-600 absolute"
                  aria-hidden="true"
                />
                <input
                  id="count_date"
                  type="text"
                  class="pl-8"
                  :value="inputValue"
                  v-on="inputEvents"
                />
              </div>
            </template>
          </DatePicker>
        </div>
        <div class="input-group col-span-1 relative">
          <label for="count_time"> Count Time </label>
          <DatePicker
            color="gray"
            mode="time"
            v-model="date"
            :timezone="timezone"
          >
            <template v-slot="{ inputValue, inputEvents }">
              <div class="relative">
                <ClockIcon
                  class="top-2.5 left-3 h-4 w-4 text-blue-600 absolute"
                  aria-hidden="true"
                />
                <input
                  id="count_time"
                  type="text"
                  class="pl-8"
                  :value="inputValue"
                  v-on="inputEvents"
                />
              </div>
            </template>
          </DatePicker>
        </div>

        <div class="input-group">
          <label for="locations"> Location </label>
          <div class="input-control">
            <select id="locations">
              <option :value="null">Location</option>
              <option>Homestead</option>
              <option>Inverness</option>
            </select>
          </div>
          <p
            v-if="getErrors('location_id', form)"
            class="input-error"
          >
            {{ getErrors('location_id', form) }}
          </p>
        </div>

        <div class="input-group">
          <label for="locations"> Type </label>
          <div class="input-control">
            <select id="locations">
              <option :value="null">Count Type</option>
              <option>Inventory</option>
              <option>Damaged</option>
              <option>Transfers</option>
              <option>Deliveries</option>
            </select>
          </div>
          <p
            v-if="getErrors('location_id', form)"
            class="input-error"
          >
            {{ getErrors('location_id', form) }}
          </p>
        </div>

        <div class="input-group col-span-2 relative">
          <label for="count_name"> Inventory Count Name </label>
          <input
            type="text"
            id="count_name"
            value="Homestead - May 16, 2022 @ 12:00"
          />
          <p
            v-if="getErrors('name', form)"
            class="input-error"
          >
            {{ getErrors('name', form) }}
          </p>
        </div>
      </div>
    </div>

    <template #footer>
      <button
        @click.prevent="submit()"
        :disabled="creating"
        type="button"
        class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-gray-100 bg-blue-600 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600 min-w-[200px]"
      >
        {{ submitText }}
      </button>
      <button
        @click="close()"
        type="button"
        class="mt-3 inline-flex justify-center rounded-md border border-gray-400 px-4 py-2 bg-gray-100 font-medium text-gray-700 shadow-sm hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-600 sm:mt-0 ml-3 w-auto text-sm"
      >
        Cancel
      </button>
    </template>
  </MediumModal>
</template>

<script>
import MediumModal from '@/Components/Modals/MediumModal.vue'
import {
  ExclamationCircleIcon,
  XCircleIcon,
  SearchIcon,
  ChevronDownIcon,
  CalendarIcon,
  ClockIcon
} from '@heroicons/vue/solid'
import { PlusCircleIcon, MinusCircleIcon } from '@heroicons/vue/outline'
import getsErrors from '@/Mixins/getsErrors'
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
import interactsWithCurrentLocation from '@/Mixins/interactsWithCurrentLocation'
import accessesCompany from '@/Mixins/accessesCompany'
import { Calendar, DatePicker } from 'v-calendar'

export default {
  mixins: [getsErrors, interactsWithCurrentLocation, accessesCompany],

  components: {
    MediumModal,
    ExclamationCircleIcon,
    XCircleIcon,
    SearchIcon,
    PlusCircleIcon,
    MinusCircleIcon,
    ChevronDownIcon,
    CalendarIcon,
    ClockIcon,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems,
    Calendar,
    DatePicker
  },

  props: {
    open: {
      type: Boolean,
      default: false
    },
    actionText: {
      type: String,
      default: 'Save'
    }
  },

  emits: ['update:open', 'created'],

  data() {
    return {
      creating: false,
      date: new Date(),
      form: this.$inertia.form({})
    }
  },

  computed: {
    errors() {
      return this.$page.props.errors.createAdjustment || {}
    },
    submitText() {
      if (this.creating) {
        return 'Saving...'
      }

      return this.actionText
    }
  },

  methods: {
    close() {
      this.$emit('update:open', false)
    },
    submit() {
      this.submitCreate()
    },
    submitCreate() {
      this.creating = true

      this.form.post(route('adjustments.store'), {
        errorBag: 'createAdjustment',
        onSuccess: (response) => {
          this.form.reset()
          this.emitCreated()
          this.creating = false
        },
        onFinish: (response) => {
          this.creating = false
        }
      })
    },
    emitCreated() {
      this.$emit('created')
    }
  }
}
</script>
